module.exports = __webpack_public_path__ + "assets/img/case-ru.74c3ceff.webp";